import React from 'react';
interface Props {
  title:string|React.ReactNode,
  img?:string,
  style?:React.CSSProperties
  id?:string
}
export default class InspectorNodeHeader extends React.Component<Props>{
    render() {
      // NOTE: TITLE  CAN ALSO TAKE COMPONENTS
      const nodeType = (this.props.title && typeof this.props.title === 'string' && this.props.title.toUpperCase) ? this.props.title.toUpperCase() : this.props.title;
      const style = (this.props.style) ? this.props.style : undefined;
        return (<div className="panelTitleRow inspectorNodeHeader" style={style}>
          <span className="headerTitle">{nodeType}</span>
        </div>);
     }
};
